/**
 * Created by Ivan on 17.05.2026
 */

const SeasonPassQuest = function (data) {
    this.id = data.id;
    this.type = data.type;
    this.goalBase = parseInt(data.goalBase || data.goal) || 1;
    this.goalPerStage = parseInt(data.goalPerStage) || 0;
    this.rewardPoints = parseInt(data.rewardPoints) || 0;
    this.repeatable = !!data.repeatable;
    this.bonus = !!data.bonus;

    this.goal = this.goalBase;
    this.progress = parseInt(data.progress) || 0;
    this.completed = !!data.completed;
};

SeasonPassQuest.prototype.resolveGoal = function (stage) {
    this.goal = this.goalBase + this.goalPerStage * (parseInt(stage) || 0);
    return this.goal;
};

SeasonPassQuest.prototype.reset = function (stage) {
    this.progress = 0;
    this.completed = false;
    this.resolveGoal(stage);
};

SeasonPassQuest.prototype.addProgress = function (amount) {
    if (this.isFinished()) {
        return false;
    }

    this.progress = Math.min(this.progress + amount, this.goal);
    if (this.isFinished()) {
        this.completed = true;
        return true;
    }
    return false;
};

SeasonPassQuest.prototype.isFinished = function () {
    return this.progress >= this.goal;
};

SeasonPassQuest.prototype.getTitle = function () {
    const key = SeasonPassQuest.TITLE_KEYS[this.type] || `SeasonPass.Quest.${this.type}`;
    return Messages.get(key, { goal: this.goal });
};

SeasonPassQuest.prototype.serialize = function () {
    return {
        id: this.id,
        progress: this.progress,
        completed: this.completed
    };
};

SeasonPassQuest.TITLE_KEYS = {
    spend_hard: "SeasonPass.Quest.SpendHard",
    make_purchase: "SeasonPass.Quest.MakePurchase",
    help_customers: "SeasonPass.Quest.HelpCustomers",
    merge_units: "SeasonPass.Quest.MergeUnits",
    complete_levels: "SeasonPass.Quest.CompleteLevels",
    spend_energy: "SeasonPass.Quest.SpendEnergy",
    complete_orders: "SeasonPass.Quest.CompleteOrders",
    merge_items: "SeasonPass.Quest.MergeItems"
};
